import script from "./form-custom.vue?vue&type=script&setup=true&lang=js"
export * from "./form-custom.vue?vue&type=script&setup=true&lang=js"

import "./form-custom.vue?vue&type=style&index=0&id=42e3a501&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42e3a501"]])

export default __exports__